import script from "./DepositPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositPaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./DepositPaymentMethod.vue?vue&type=style&index=0&id=ab6e65e4&scoped=true&lang=css"
import "./DepositPaymentMethod.vue?vue&type=style&index=1&id=ab6e65e4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab6e65e4"]])

export default __exports__